import { apiClient } from '../../api/client';
import type { components } from '../../api/generated/schema';
import type { SignupRequest, SocialProvider } from '../../domain/account';
import type { MarketplaceConfig } from '../../domain/config';
import { mapped } from '../errors';
import type { SessionRepository } from './SessionRepository';

type S = components['schemas'];

export function toSignupRequest(r: SignupRequest): S['SignupRequest'] {
  return {
    first_name: r.firstName,
    last_name: r.lastName,
    ...(r.username && { username: r.username }),
    ...(r.email && { email: r.email }),
    ...(r.phone && { phone: r.phone }),
    password: r.password,
    accepted_terms: true,
    terms_version: r.termsVersion,
  };
}

/** Reads the session Django served the page with; signing in and out are page loads. */
export const httpSessionRepository: SessionRepository = {
  current: (): MarketplaceConfig => window.MARKETPLACE_CONFIG ?? {},
  signInUrl: (next: string) => `/accounts/login/?next=${encodeURIComponent(next)}`,
  signOutUrl: () => '/accounts/logout/',
  signUp: (request: SignupRequest) =>
    mapped(async () => {
      await apiClient.send('POST', '/api/v1/auth/signup/', toSignupRequest(request));
    }),
  // Through the agreement endpoint, which remembers that the person agreed to
  // the terms (shown beside these buttons) before handing off to allauth.
  socialSignInUrl: (provider: SocialProvider, next: string) =>
    `/accounts/agree/${provider}/?next=${encodeURIComponent(next)}`,
};
